<script>
import Base from '@backend/Base.vue';

export default {
  extends: Base,
  data(){
    return {
      Name:"Dashboard",
      input: {},
      var2: {},
      testGallery:""
    }
  },
  mounted(){
    this.$set(this.$root, 'page', this)    
  },
  methods:{}
}
</script>

<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 offset-md-3">
          <div class="wrap_welcome">
            <img :src="assets('images','welcome_page.png')" />
            <div class="intro mt_10">
              <h3>Hello,<strong> {{user.employeename}}</strong> </h3>
              <p>You are using Facility Management System version 1.0.</p>
              <p style="margin-top:40px;">{{"now".dates("format3")}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
